var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-app",
    { attrs: { "full-height": "" } },
    [
      _c("LFCustomTooltipComponent"),
      _c("LFToastsContainerComponent"),
      _c("SpinnerComponent"),
      _vm.showSpinnerLayer
        ? _c("SpinnerLayerComponent", {
            staticClass: "spinner-layer-component",
          })
        : _vm._e(),
      _c("DialogComponent"),
      _c("CustomDialogComponent"),
      _c(
        "v-main",
        {
          class: {
            "remove-padding": _vm.removeMainPadding,
            "is-mobile": _vm.renderMobileViews,
          },
        },
        [
          _c(
            "div",
            { staticClass: "alerts-container" },
            [
              _c("AlertComponent", {
                attrs: { whereIsRendered: _vm.componentWhereIsRendered },
              }),
            ],
            1
          ),
          _c(
            "v-container",
            { staticClass: "app-container", attrs: { fluid: "", "pa-0": "" } },
            [
              !_vm.hideNavigation && _vm.renderNavigationGetter
                ? _c("NavigationContainerComponent", {
                    attrs: {
                      isFooterVisible: _vm.isFooterVisible,
                      drawerHeight: _vm.drawerHeight,
                    },
                  })
                : _vm._e(),
              _c("router-view", { key: _vm.ckeckIfReloadURL }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showLandbot ? _c("LandbotLoader") : _vm._e(),
      _c("LefebvreFooterComponent", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showFooter,
            expression: "showFooter",
          },
        ],
        ref: "footer",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }